export enum bahai_communicationtypecode {
  InPersonMeeting = 200630000,
  HomeVisit = 200630001,
  PhoneCall = 200630002,
  TextMessage = 200630003,
  Mail = 200630004,
  ParticipatedinActivity = 200630005,
  HostingActivity = 200630006,
  VirtualMeeting = 200630007,
  TeachingCampaign = 200630008,
  CommentOnly = 200630009,
  Email = 200630010,
}

export enum statecode {
  Active = 0,
  Inactive = 1,
}

export enum bahai_communicationreason {
  ChildrenClasses = 200630008,
  Confidential = 200630014,
  DeepeningThemes = 200630005,
  Devotional = 200630007,
  Fireside = 200630004,
  Followup = 200630001,
  ForwardedtoLocalContact = 200630017,
  HolyDayobservance = 200630006,
  InitialContact = 200630000,
  InspirationalStory = 200630016,
  JuniorYouthGroup = 200630010,
  Leftvoicemail = 200630019,
  Other = 200630015,
  OverviewoftheBahaiFaith = 200630002,
  ResponsefromLocalContact = 200630018,
  StudyCircle = 200630009,
}
